var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Nav',{attrs:{"defaultPath":"/successCases"}}),_c('Case',{staticClass:"needVisible"}),_c('ContactUs'),(_vm.showGoTop)?_c('div',{staticClass:"totop",on:{"click":function($event){$event.stopPropagation();return _vm.toTop()}}},[_c('img',{attrs:{"src":"https://4d-ai.chat/img/totop.png"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }